import * as React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import { change, formValueSelector } from 'redux-form';
import { compose, withHandlers } from 'recompose';

import {
  InputField,
  Date,
  DateField,
  RemoteAutoCompleteField,
  RemoteAutoComplete,
  FormattedNumberInput,
  RemoteChipInputField,
  RemoteChipInput,
  Input
} from '@components/form';
import { required } from '@utils/validators';
import { formatFloat, floatOnly, integerOnly, formatToDecimals } from '@utils/utils';

import * as T from '@modules/trips/_tripsTypes';
import { connect } from 'react-redux';

export const enhance = compose<any, any>(
  connect(state => {
    return {
      startMileage: formValueSelector('Trips')(state, 'startMileage')
    };
  }),
  withHandlers<any, T.Trip>({
    handleCarChange: ({ dispatch, startMileage }) => async ({ mileage }) => {
      if (startMileage === undefined) {
        dispatch(change('Trips', 'startMileage', mileage));
      }
    }
  })
);

const View: React.SFC<any> = ({ dispatch, startMileage, endMileage, handleCarChange }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col md={3} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Základní údaje</h4>
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                label="Řidič *"
                name="officer"
                id="officer"
                url="/metropolis/api/hr/employees"
                fullWidth={true}
                labelFunction={o => get(o, 'fullName')}
                validate={[required]}
              />
            </Col>
            <Col md={12}>
              <RemoteAutoCompleteField
                component={RemoteAutoComplete}
                label="Služební vozidlo *"
                name="vehicle"
                id="vehicle"
                url="/metropolis/api/cl/vehicles"
                fullWidth={true}
                labelFunction={o => get(o, 'fullName')}
                validate={[required]}
                onChange={handleCarChange}
              />
            </Col>
            <Col md={12}>
              <RemoteChipInputField
                component={RemoteChipInput}
                style={{ position: 'relative' }}
                label="Spolujezdci"
                name="passengers"
                id="passengers"
                url="/metropolis/api/hr/employees"
                fullWidth={true}
                labelFunction={o => get(o, 'fullName')}
              />
            </Col>
            <Col md={12}>
              <InputField
                component={Input}
                multiLine={true}
                id="note"
                label="Poznámka"
                name="note"
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
            <Col md={12}>
              <InputField
                component={Input}
                name={'transfer'}
                id={'transfer'}
                label={'Předávka'}
                style={{ maxHeight: '60vh' }}
                inputStyle={{ maxHeight: '60vh' }}
                textareaStyle={{ maxHeight: '56vh' }}
              />
            </Col>
          </Row>
        </Col>
        <Col md={3} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Čas jízdy</h4>
            </Col>
            <Col md={12}>
              <DateField
                component={Date}
                name={'startTime'}
                id={'startTime'}
                label={'Začátek jízdy *'}
                dateOnly={false}
                validate={[required]}
              />
            </Col>
            <Col md={12}>
              <DateField
                component={Date}
                name={'endTime'}
                id={'endTime'}
                label={'Konec jízdy *'}
                dateOnly={false}
                validate={[required]}
                allowFuture={true}
              />
            </Col>
          </Row>
        </Col>
        <Col md={3} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Tankování</h4>
            </Col>

            <Col md={12}>
              <InputField
                component={FormattedNumberInput}
                id={'refuelingAmount'}
                name={'refuelingAmount'}
                label={'Natankované množství'}
                normalize={floatOnly}
                format={formatFloat}
              />
            </Col>
            <Col md={12}>
              <InputField
                component={FormattedNumberInput}
                id={'refuelingPrice'}
                name={'refuelingPrice'}
                label={'Cena tankovaného paliva'}
                normalize={floatOnly}
                format={v => formatToDecimals(v)}
              />
            </Col>
          </Row>
        </Col>
        <Col md={3} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Nájezd</h4>
            </Col>
            <Col md={12}>
              <InputField
                component={FormattedNumberInput}
                id={'startMileage'}
                name={'startMileage'}
                label={'Počáteční nájezd *'}
                onChange={(_event, newValue) =>
                  dispatch(change('Trips', 'totalMileage', endMileage - newValue.replace(/ /g, '')))
                }
                validate={[required]}
                normalize={integerOnly}
              />
            </Col>
            <Col md={12}>
              <InputField
                component={FormattedNumberInput}
                id={'endMileage'}
                name={'endMileage'}
                label={'Konečný nájezd *'}
                onChange={(_event, newValue) =>
                  dispatch(change('Trips', 'totalMileage', newValue.replace(/ /g, '') - startMileage))
                }
                validate={[required]}
                normalize={integerOnly}
              />
            </Col>
            <Col md={12}>
              <InputField
                component={FormattedNumberInput}
                id={'totalMileage'}
                name={'totalMileage'}
                label={'Celkový nájezd'}
                disabled={true}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Grid>
    <Divider />
  </div>
);
export const TripsFormBasic = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/trips/TripsFormBasic.tsx